import companyLogo from "@assets/images/S&P_Global_logo.svg"
import React from "react"
import { Button } from "@mui/material"

type ForbiddenProps = {
  url: string
}

export default function Forbidden({ url }: ForbiddenProps) {
  const mailto = import.meta.env.VITE_SUPPORT_CONTACT

  return (
    <div className="displayContainer">
      <img className="companyLogo" src={companyLogo} alt="S&P Global" />
      <h1>
        403 Access Denied <b>:(</b>
      </h1>
      <h2>You are not permitted to access {url}</h2>
      <p>
        Please contact <a href={`mailto:${mailto}`}>{mailto}</a> for support, or if you believe this
        to be in error.
      </p>
      <Button href="/" variant="contained">
        Go back to home
      </Button>
    </div>
  )
}
